import AjaxClass from '@/ajax'

export default class TestQuestionService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getList (then, params) {
    return this.ajax.get('/test_questions', params, (data) => {
      sessionStorage.removeItem('hiddenLoading')
      return then(data)
    }, {hiddenLoading: !!sessionStorage.getItem('hiddenLoading')})
  }

  getItem (id, then, params) {
    return this.ajax.get('/test_questions/' + id, params, (data) => {
      return then(data)
    })
  }

  saveItem (item, update, then) {
    return this.ajax.post('/test_questions/save', {item: item, update: update}, (data) => {
      then(data)
    })
  }

  deleteItem (id, then) {
    return this.ajax.post('/test_questions/delete', {id: id}, (data) => {
      then(data)
    })
  }

  static getDefaultItem () {
    return {
      id: '',
      number: '',
      category: '',
      text: '',
      needFixAnswers: false,
      answers: [{id: 0, text: ''}, {id: 1, text: ''}, {id: 2, text: ''}, {id: 3, text: ''}],
      rightAnswer: {id: -1}
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/TestQuestionService.js